import React, { Component } from 'react';
import { TableContainer, Table, TableHead, TableBody } from '@material-ui/core';

import AirspaceRow from './AirspaceRow';

export default class AirspaceTable extends Component {

    render() {
        const {airspaces } = this.props;

        return (
            <TableContainer className=''>
                <Table stickyHeader>
                    <TableHead>
                    </TableHead>
                    <TableBody>
                        {airspaces && airspaces.map((a, i) => <AirspaceRow key={i} airspace={a} /> ) }
                    </TableBody>
                </Table>
            </TableContainer>
        )
    }
}